import config from './config';
import './2021-poster-challenge';
import initCreativeChallenge from './creative-challenge/creative-challenge-init';

initCreativeChallenge(
  '2022-photo-challenge',
  config.staticFile('features/2022-photo-challenge'),
  ['p', 'l', 'w'],
  {
    itemsPerPage: 27 * 6,
    photoRoutePrefix: '2022-pc-photo-',
  }
);

initCreativeChallenge(
  '2023-comic-challenge',
  config.staticFile('features/2023-comic-challenge'),
  ['d'],
  {
    itemsPerPage: 27 * 6,
    photoRoutePrefix: '2023-cc-photo-',
  }
);

initCreativeChallenge(
  '2024-math-remix-challenge',
  config.staticFile('features/2024-math-remix-challenge'),
  ['gallery'],
  {
    itemsPerPage: 12 * 6,
    photoRoutePrefix: '2024-mrc-photo-',
  }
);

initCreativeChallenge(
  '2025-creative-challenge',
  config.staticFile('features/2025-creative-challenge'),
  ['gallery'],
  {
    itemsPerPage: 12 * 6,
    photoRoutePrefix: '2025-cc-photo-',
  }
);
